import { useEffect, useState } from 'react';

const DESKTOP_QUERY = '(min-width: 768px)';

/**
 * Read once via lazy init, then subscribe: unlike a preference that never
 * changes while a component is mounted, a viewport width can change through
 * a resize while `AppShell` stays mounted, so the sidebar/drawer switch has
 * to react to it.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(DESKTOP_QUERY);
    const onChange = (): void => setIsDesktop(mediaQueryList.matches);

    mediaQueryList.addEventListener('change', onChange);
    return () => mediaQueryList.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
